"use strict";
import { PrivyProvider } from "@privy-io/react-auth";
import { PrivyWagmiBridge } from "components/Web3Provider/privy/PrivyWagmiBridge";
import { PRIVY_DEFAULT_CHAIN, PRIVY_SUPPORTED_CHAINS } from "components/Web3Provider/wagmiConfig";
const PRIVY_APP_ID = process.env.REACT_APP_PRIVY_APP_ID?.trim();
const PRIVY_CLIENT_ID = process.env.REACT_APP_PRIVY_CLIENT_ID?.trim();
export const PRIVY_ENABLED = Boolean(PRIVY_APP_ID);
export function PrivyAppProvider({ children }) {
  if (!PRIVY_APP_ID) {
    return <>{children}</>;
  }
  return <PrivyProvider
    appId={PRIVY_APP_ID}
    {...PRIVY_CLIENT_ID ? { clientId: PRIVY_CLIENT_ID } : {}}
    config={{
      loginMethods: ["email", "google"],
      defaultChain: PRIVY_DEFAULT_CHAIN,
      supportedChains: PRIVY_SUPPORTED_CHAINS,
      embeddedWallets: {
        ethereum: { createOnLogin: "users-without-wallets" }
      },
      appearance: { walletChainType: "ethereum-only", theme: "dark", accentColor: "#FE3C00" }
    }}
  >
      {children}
    </PrivyProvider>;
}
export function PrivyBridge({ children }) {
  if (!PRIVY_ENABLED) {
    return <>{children}</>;
  }
  return <PrivyWagmiBridge>{children}</PrivyWagmiBridge>;
}
